// https://github.com/vercel/next.js/blob/canary/examples/with-react-relay-network-modern/lib/createEnvironment/index.js
export const { initEnvironment, createEnvironment } =
  typeof window === 'undefined' ? require('./server') : require('./client');

export * from './fetch';
